import { useTranslation } from "react-i18next";

import { useTeams, type Team } from "@/api/queries";
import { useCurrentUser } from "@/app/auth";
import { NativeSelect } from "@/components/ui/input";

/** Teams the current user may filter by: all for administrators, managed ones for managers. */
// eslint-disable-next-line react-refresh/only-export-components
export function useScopeTeams(): Team[] {
  const me = useCurrentUser();
  const teams = useTeams();
  const list = teams.data ?? [];
  if (me.role === "admin") return list;
  return list.filter((team) => team.members.some((m) => m.user_id === me.id && m.is_manager));
}

type TeamSelectProps = {
  value: string | undefined;
  onChange: (teamId: string | undefined) => void;
  className?: string;
  /** Label of the "no team" option. */
  allLabel?: string;
};

/** "All people" or one team. Hidden when there is nothing to choose from. */
export function TeamSelect({ value, onChange, className, allLabel }: TeamSelectProps) {
  const { t } = useTranslation();
  const teams = useScopeTeams();
  if (teams.length === 0) return null;
  return (
    <NativeSelect
      aria-label={t("scope.team")}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value || undefined)}
      className={className}
    >
      <option value="">{allLabel ?? t("scope.allPeople")}</option>
      {teams.map((team) => (
        <option key={team.id} value={team.id}>
          {team.name}
        </option>
      ))}
    </NativeSelect>
  );
}
